import { useEffect, useState } from "react"
import PageTitle from "../../../components/Accessibility/PageTitle"
import { getAvaliacao } from "../../../services/AvaliacaoEspacoPersonal"
import { Typography } from "@mui/material"
import { sxTitle } from "./sxProps"
import './styles.css';
import { Avaliacao } from "../../../interfaces/entities/SaudeOnline/AvaliacaoEspacoPersonal"
import AvaliacaoBox from "./AvaliacaoBox"
import LoadingApp from "../../../components/LoadingApp"
import ModalFeedBack from "../../../components/ModalFeedBack"
import { ModalFeedBackProps } from "../../../interfaces/props/ModalFeedBackProps"

const AvaliacaoEspacoPersonal = () => {
    const [lstAtendConsult, setLstAtendConsult] = useState<Avaliacao[]>([]);
    const [lstTelemed, setLstTelemed] = useState<Avaliacao[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [modalFeedback, setModalFeedback] = useState<null | ModalFeedBackProps>(null);

    const showFeedbackModal = (config: ModalFeedBackProps) => {
        setModalFeedback({
            ...config,
            handleShowModal: config.handleShowModal || (() => setModalFeedback(null)),
            handleButtonModal: config.handleButtonModal || (() => {
                setModalFeedback(null);
            }),
        });
    };

    const handleGetAvaliacao = () => {
        setLoading(true)
        getAvaliacao().then((response) => {
            setLstAtendConsult(response.lstAtendConsult)
            setLstTelemed(response.lstTelemed)
        }).catch(() => {
            showFeedbackModal({
                icon: "error",
                title: "Erro",
                subTitle: "Ocorreu um erro. Tente novamente em instantes.",
                textButton: "Fechar",
                showButtonModal: true,
                showModal: true
            });
        }).finally(() => setLoading(false))
    };

    useEffect(() => {
        handleGetAvaliacao()
    }, []);

    return (
        <div className="page-container">
            <PageTitle text="Avaliações Espaço Personal" />
            {lstAtendConsult?.length > 0 &&
                <>
                    <Typography component="h2" sx={sxTitle}>Atendimento de Consultas (eletivas)</Typography>
                    {lstAtendConsult?.map((item) =>
                        <AvaliacaoBox {...item} />
                    )}
                </>
            }
            {lstTelemed?.length > 0 && <>
                <Typography component="h2" sx={sxTitle}>Telemedicina</Typography>
                {lstTelemed?.map((item) =>
                    <AvaliacaoBox {...item} />
                )}
            </>
            }
            <LoadingApp showLoading={loading} />
            <ModalFeedBack
                showModal={!!modalFeedback}
                handleShowModal={modalFeedback?.handleShowModal}
                title={modalFeedback?.title as string}
                subTitle={modalFeedback?.subTitle as string}
                icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
                showButtonModal={modalFeedback?.showButtonModal}
                textButton={modalFeedback?.textButton as string}
                handleButtonModal={modalFeedback?.handleButtonModal}
                classNameModal="modal-custom"
            />
        </div>
    )
}

export default AvaliacaoEspacoPersonal